import { apiSendJson, apiSendJsonAndFiles, apiSend, apiSendNamedFiles } from "@/api/apicommon"
import { PatientDocumentUiDto } from "@/models/patientDocument.model"
import { StructuredDoseDto } from "@/models/structuredDoseDto"

export default {
    async getRefResultKeys(conclusionGroupId: string) {
        const method = "POST"
        const endpoint = "/clinical/getRefResultKeys/"
        const json = {
            "conclusionGroupId": conclusionGroupId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addOfficialTemplateToCcl(conclusionGroupId: string, internalCode: string, originalText: string, mainFieldText: string, healthProType: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addOfficialTemplateToCcl/"
        const json = {
            "entryId": entryId,
            "conclusionGroupId": conclusionGroupId,
            "internalCode": internalCode,
            "originalText": originalText,
            "mainFieldText": mainFieldText,
            "healthProType": healthProType,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addOfficialTemplateToCclZero(internalCode: string, originalText: string, mainFieldText: string, healthProType: string, entryId: string, financialGroupId: string | null) {
        const method = "POST"
        const endpoint = "/clinical/addOfficialTemplateToCclZero/"
        const json = {
            "entryId": entryId,
            "internalCode": internalCode,
            "originalText": originalText,
            "mainFieldText": mainFieldText,
            "healthProType": healthProType,
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addReferenceTemplateToCcl(entryId: string, conclusionGroupId: string, referenceDocumentId: string) {
        const method = "POST"
        const endpoint = "/clinical/addReferenceTemplateToCcl/"
        const json = {
            "entryId": entryId,
            "conclusionGroupId": conclusionGroupId,
            "referenceDocumentId": referenceDocumentId,
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async updatePatientDocumentFinancialGroup(entryId: string, patientDocumentId: string, financialGroupId: string) {
        const method = "POST"
        const endpoint = "/clinical/updatePatientDocumentFinancialGroup/"
        const json = {
            "entryId": entryId,
            "patientDocumentId": patientDocumentId,
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addCustomTemplateToCcl(conclusionGroupId: string, documentGroupId: string, originalText: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addCustomTemplateToCcl/"
        const json = {
            "entryId": entryId,
            "conclusionGroupId": conclusionGroupId,
            "documentGroupId": documentGroupId,
            "originalText": originalText
        }
        return await apiSendJson(method, endpoint, json)
    },
        async getDocumentGroupByText(documentTitle: string) {
        const method = "POST"
        const endpoint = "/clinical/getDocumentGroupByText/"
        const json = {
            "documentTitle": documentTitle,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateUiSelectorData(uiSelectorDataId: string, newString: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/updateUiSelectorData/"
        const json = {
            "entryId": entryId,
            "uiSelectorDataId": uiSelectorDataId,
            "newString": newString
        }
        return await apiSendJson(method, endpoint, json)
    },
    async changeCurrentPatientEntryDate(newEntryDate: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/changeCurrentPatientEntryDate/"
        const json = {
            "entryId": entryId,
            "newEntryDate": newEntryDate
        }
        return await apiSendJson(method, endpoint, json)
    },
    async setNewDocDefaultText(patientDocumentId: string, newString: string) {
        const method = "POST"
        const endpoint = "/clinical/setNewDocDefaultText/"
        const json = {
            "patientDocumentId": patientDocumentId,
            "newString": newString
        }
        return await apiSendJson(method, endpoint, json)
    },
    async finalizePatientDocument(patientDocumentId: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/finalizePatientDocument/"
        const json = {
            "entryId": entryId,
            "patientDocumentId": patientDocumentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async eTransmitPatientDocument(patientDocumentId: string) {
        const method = "POST"
        const endpoint = "/clinical/eTransmitPatientDocument/"
        const json = {
            "patientDocumentId": patientDocumentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async duplicatePatientDocument(patientDocumentId: string, conclusionGroupId: string, entryId: string, newVersion?: boolean) {
        const method = "POST"
        const endpoint = "/clinical/duplicatePatientDocument/"
        const json = {
            "entryId": entryId,
            "patientDocumentId": patientDocumentId,
            "conclusionGroupId": conclusionGroupId,
            "newVersion": newVersion
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deletePatientDocument(patientDocumentId: string) {
        const method = "POST"
        const endpoint = "/clinical/deletePatientDocument/"
        const json = {
            "patientDocumentId": patientDocumentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getPatientDocument(patientDocumentId: string, entryId: string): Promise<PatientDocumentUiDto> {
        const method = "POST"
        const endpoint = "/clinical/getPatientDocument/"
        const json = {
            "entryId": entryId,
            "patientDocumentId": patientDocumentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getPatientDocumentPdfStream(patientDocumentId: string) {
        const method = "POST"
        const endpoint = "/clinical/getPatientDocumentPdfStream/"
        const json = {
            "patientDocumentId": patientDocumentId
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async getResultDocumentStream(expression_CclId: string) {
        const method = "POST"
        const endpoint = "/clinical/getResultDocumentStream/"
        const json = {
            "expression_CclId": expression_CclId
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async getPatientInfo(patientId: string) {
        const method = "GET"
        const endpoint = "/clinical/patients/" + patientId + "/patient-info"
        return await apiSend(method, endpoint)
    },    
    async getLastEntry(patientId: string) {
        const method = "GET"
        const endpoint = "/patients/" + patientId + "/last-consultations"
        return await apiSend(method, endpoint)
    },
    async getAllEntries(patientId: string) {
        const method = "GET"
        const endpoint = "/clinical/patients/{patientId}/entries".replace(`{${"patientId"}}`,patientId)
        return await apiSend(method, endpoint)
    },
    async getCommonConcept(patientId: string) {
        const method = "GET"
        const endpoint = "/clinical/patients/{patientId}/common-concept".replace(`{${"patientId"}}`,patientId)
        return await apiSend(method, endpoint)
    },
    async getConcept(patientId: string) {
        const method = "GET"
        const endpoint = "/clinical/patients/{patientId}/concept".replace(`{${"patientId"}}`,patientId)
        return await apiSend(method, endpoint)
    },
    async evaluateCclText(conclusionText: string) {
        const method = "POST"
        const endpoint = "/clinical/evaluateCclText/"
        const json = {
            "conclusionText": conclusionText
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addAtcd(originalText: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addAtcd/"
        const json = {
            "originalText": originalText,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addEcosystem(originalText: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addEcosystem/"
        const json = {
            "originalText": originalText,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addMonitored(originalText: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addMonitored/"
        const json = {
            "entryId": entryId,
            "originalText": originalText
        }
        return await apiSendJson(method, endpoint, json)
    },
    async evolveExpression(entryId: string, expression_CclId: string, updatedText: string, patientSummaryId: string | undefined) {
        const method = "PUT"
        const endpoint = "/clinical/evolveExpression/"
        const json = {
            "relationId": entryId,
            "expression_CclId": expression_CclId,
            "updatedText": updatedText,
            "patientSummaryId": patientSummaryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateSapPatientInfo(conceptGroupId: string, patientInfo: string) {
        const method = "PUT"
        const endpoint = `/concept-groups/${conceptGroupId}/sap-patient-info`
        const json = {
            "patientInfo": patientInfo,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateSapPharmacyInfo(conceptGroupId: string, pharmacyInfo: string) {
        const method = "PUT"
        const endpoint = `/concept-groups/${conceptGroupId}/sap-pharmacy-info`
        const json = {
            "pharmacyInfo": pharmacyInfo,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateSapPharmacyPrescription(conceptGroupId: string, pharmacyPrescriptionType: string, customPrescriptionDays: number | null) {
        const method = "PUT"
        const endpoint = `/concept-groups/${conceptGroupId}/sap-pharmacy-prescription`
        const json = {
            "pharmacyPrescriptionType": pharmacyPrescriptionType,
            "customPrescriptionDays": customPrescriptionDays,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async evolveSapFull(expression_CclId: string, newSapName: string, newRoute: string, newGalenic: string, newMultiDosageText: string, doses: StructuredDoseDto[], entryId: string, patientTreatmentId: string) {
        const method = "PUT"
        const endpoint = "/clinical/evolveSapFull/"
        const json = {
            "entryId": entryId,
            "expression_CclId": expression_CclId,
            "newSapName": newSapName,
            "newRoute": newRoute,
            "newGalenic": newGalenic,
            "newMultiDosageText": newMultiDosageText,
            "doses": doses,
            "patientTreatmentId": patientTreatmentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async stopConcept(expression_CclId: string, expressionId: string, entryId: string, patientTreatmentId: string) {
        const method = "PUT"
        const endpoint = "/clinical/stopConcept/"
        const json = {
            "expression_CclId": expression_CclId,
            "expressionId": expressionId,
            "entryId": entryId,
            "patientTreatmentId": patientTreatmentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addSapToNullConclusion(newSapName: string, newRouteTerm: string, newGalenic: string, newMultidosage: string, doses: StructuredDoseDto[], entryId: string, defaultPatientInfo: string | null = null, defaultPharmacyInfo: string | null = null) {
        const method = "POST"
        const endpoint = "/clinical/addSapToNullConclusion/"
        const json = {
            "entryId": entryId,
            "newSapName": newSapName,
            "newRouteTerm": newRouteTerm,
            "newGalenic": newGalenic,
            "newMultidosage": newMultidosage,
            "doses": doses,
            "defaultPatientInfo": defaultPatientInfo,
            "defaultPharmacyInfo": defaultPharmacyInfo,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addSapToConclusion(conclusionGroupId: string, newSapName: string, newRouteTerm: string, newGalenic: string, newMultidosage: string, doses: StructuredDoseDto[], entryId: string, defaultPatientInfo: string | null = null, defaultPharmacyInfo: string | null = null) {
        const method = "POST"
        const endpoint = "/clinical/addSapToConclusion/"
        const json = {
            "entryId": entryId,
            "conclusionGroupId": conclusionGroupId,
            "newSapName": newSapName,
            "newRouteTerm": newRouteTerm,
            "newGalenic": newGalenic,
            "newMultidosage": newMultidosage,
            "doses": doses,
            "defaultPatientInfo": defaultPatientInfo,
            "defaultPharmacyInfo": defaultPharmacyInfo,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addBioPrescriptionsToConclusion(conclusionGroupId: string, originalTexts: string[]) {
        const method = "POST"
        const endpoint = "/clinical/addBioPrescriptionToConclusion/"
        const json = {
            "conclusionGroupId": conclusionGroupId,
            "originalTexts": originalTexts,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteExpressionPrescription(expression_CclId: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/deleteExpressionPrescription/"
        const json = {
            "entryId": entryId,
            "expression_CclId": expression_CclId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteSap(expression_CclId: string, entryId: string, patientTreatmentId: string) {
        const method = "DELETE"
        const endpoint = "/clinical/deleteSap/"
        const json = {
            "entryId": entryId,
            "expression_CclId": expression_CclId,
            "patientTreatmentId": patientTreatmentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateExpressionIsMarked(expression_CclId: string, isMarked: boolean) {
        const method = "POST"
        const endpoint = "/clinical/updateExpressionIsMarked/"
        const json = {
            "expression_CclId": expression_CclId,
            "isMarked": isMarked
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateExpressionText(expression_CclId: string, newText: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/updateExpressionText/"
        const json = {
            "expression_CclId": expression_CclId,
            "updatedText": newText,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async insertNewBlankConclusion(entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/insertNewBlankConclusion/"
        const json = {
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async setConceptGroupForExpression(expressionId: string, importanceType: string, entryId: string, patientSummaryId: string | undefined) {
        const method = "PUT"
        const endpoint = "/clinical/setConceptGroupForExpression/"
        const json = {
            "expressionId": expressionId,
            "importanceType": importanceType,
            "entryId": entryId,
            "patientSummaryId": patientSummaryId
        }
        return await apiSendJson(method, endpoint, json)
    },

    async deleteExpression(expression_CclId: string, entryId: string, patientSummaryId: string | undefined) {
        const method = "DELETE"
        const endpoint = "/clinical/deleteExpression/"
        const json = {
            "entryId": entryId,
            "expression_CclId": expression_CclId,
            "patientSummaryId": patientSummaryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addResultAfterCurrent(expression_CclId: string, newText: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addResultAfterCurrent/"
        const json = {
            "expression_CclId": expression_CclId,
            "originalText": newText,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateConclusionText(conclusionGroupId: string, newText: string) {
        const method = "POST"
        const endpoint = "/clinical/updateConclusionText/"
        const json = {
            "conclusionGroupId": conclusionGroupId,
            "conclusionText": newText
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addAssessmentCcl(assessedExpressionId: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addAssessmentCcl/"
        const json = {
            "assessedExpressionId": assessedExpressionId,
            "entryId": entryId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addAssessmentCclFromTitleSuggestion(entryId: string, newGroupTitle: string) {
        const method = "POST"
        const endpoint = "/clinical/addAssessmentCclFromTitleSuggestion/"
        const json = {
            "entryId": entryId,
            "newGroupTitle": newGroupTitle,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addFilesAfterCurrent(expression_CclId: string, entryId: string, files: File[]) {
        const method = "POST"
        const endpoint = "/clinical/addFilesAfterCurrent/"
        const json = {
            "entryId": entryId,
            "expression_CclId": expression_CclId,
        }
        return await apiSendJsonAndFiles(method, endpoint, json, files)
    },
    async checkPatientEntry(patientId: string) {
        const method = "GET"
        const endpoint = `/ophtalmology/patients/${patientId}/check-patient-entry`

        return await apiSend(method, endpoint);
    },
    async importOphthalmicMeasurement(patientId: string, measurementType: string, files: Record<string, File>) {
        const method = "POST"
        const endpoint = `/ophtalmology/patients/${patientId}/measurements?measurementType=${measurementType}`

        return await apiSendNamedFiles(method, endpoint, files)
    },
    async updateOphthalmicFields(patientId: string, measurementType: string, fields: Record<string, string>) {
        const method = "POST";
        const endpoint = `/ophtalmology/patients/${patientId}/measurements/fields?measurementType=${measurementType}`;
        return await apiSendJson(method, endpoint, { fields });
    },
    async generateMeasureInputFile(patientId: string, measurementType: string) {
        const method = "GET"
        const endpoint = `/ophtalmology/patients/${patientId}/measurements/input-files?measurementType=${measurementType}`
        return await apiSend(method, endpoint, true, true)
    },
    async getPatientDashboardOphtalmo(patientId: string) {
        const method = "GET"
        const endpoint = `/ophtalmology/patients/${patientId}/dashboards`
        return await apiSend(method, endpoint)
    },
    async fileToResults(expression_CclId: string) {
        const method = "POST"
        const endpoint = "/clinical/fileToResults/"
        const json = {
            "expression_CclId": expression_CclId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async precompletePatientDocumentWithBill(patientDocumentId: string, financialGroupId: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/precompletePatientDocumentWithBill/"
        const json = {
            "patientDocumentId": patientDocumentId,
            "financialGroupId": financialGroupId,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addLuActToLuBill(luBillId: string, luActCode: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addLuActToLuBill/"
        const json = {
            "luBillId": luBillId,
            "luActCode": luActCode,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addLuActsToLuBillUntilEndDate(luBilledActId: string, startDate: string, endDate: string) {
        const method = "POST"
        const endpoint = "/clinical/addLuActsToLuBillUntilEndDate/"
        const json = {
            "luBilledActId": luBilledActId,
            "startDate": startDate,            
            "endDate": endDate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAllFollowingLuActsToNewClass(luBilledActId: string) {
        const method = "POST"
        const endpoint = "/clinical/updateAllFollowingLuActsToNewClass/"
        const json = {
            "luBilledActId": luBilledActId,
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async separateCombinedAct(luBilledActId: string) {
        const method = "POST"
        const endpoint = "/clinical/separateCombinedAct/"
        const json = {
            "luBilledActId": luBilledActId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addAppUserLuActToLuBill(luBillId: string, appUserLuActId: string, entryId: string) {
        const method = "POST"
        const endpoint = "/clinical/addAppUserLuActToLuBill/"
        const json = {
            "luBillId": luBillId,
            "appUserLuActId": appUserLuActId,
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuBillAdditionalInfo(luBillId: string, additionalInfoCode: string) {
        const method = "POST"
        const endpoint = "/clinical/updateLuBillAdditionalInfo/"
        const json = {
            "luBillId": luBillId,
            "additionalInfoCode": additionalInfoCode
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteLuBilledAct(luBilledActId: string) {
        const method = "POST"
        const endpoint = "/clinical/deleteLuBilledAct/"
        const json = {
            "luBilledActId": luBilledActId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateActDate(luBilledActId: string, actDate: string) {
        const method = "POST"
        const endpoint = "/clinical/updateActDate/"
        const json = {
            "luBilledActId": luBilledActId,
            "actDate": actDate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePrefix(luBilledActId: string, prefix: string | null) {
        const method = "POST"
        const endpoint = "/clinical/updatePrefix/"
        const json = {
            "luBilledActId": luBilledActId,
            "prefix": prefix,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateSuffix(luBilledActId: string, suffix: string) {
        const method = "POST"
        const endpoint = "/clinical/updateSuffix/"
        const json = {
            "luBilledActId": luBilledActId,
            "suffix": suffix,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addSurgeryAssistance(luBilledActId: string, misaNumber: string) {
        const method = "POST"
        const endpoint = "/clinical/addSurgeryAssistance/"
        const json = {
            "luBilledActId": luBilledActId,
            "misaNumber": misaNumber,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateMisaNumber(luBilledActId: string, misaNumber: string) {
        const method = "POST"
        const endpoint = "/clinical/updateMisaNumber/"
        const json = {
            "luBilledActId": luBilledActId,
            "misaNumber": misaNumber,
        }
        return await apiSendJson(method, endpoint, json)
    },        
    async updateNumberMultiplier(luBilledActId: string, numberMultiplier: string) {
        const method = "POST"
        const endpoint = "/clinical/updateNumberMultiplier/"
        const json = {
            "luBilledActId": luBilledActId,
            "numberMultiplier": numberMultiplier,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateFee(luBilledActId: string, fee: string) {
        const method = "POST"
        const endpoint = "/clinical/updateFee/"
        const json = {
            "luBilledActId": luBilledActId,
            "fee": fee,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateLuLocationMainCode(luBilledActId: string, luLocationMainCode: string) {
        const method = "POST"
        const endpoint = "/clinical/updateLuLocationMainCode/"
        const json = {
            "luBilledActId": luBilledActId,
            "luLocationMainCode": luLocationMainCode,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuLocationSubCode(luBilledActId: string, luLocationSubCode: string) {
        const method = "POST"
        const endpoint = "/clinical/updateLuLocationSubCode/"
        const json = {
            "luBilledActId": luBilledActId,
            "luLocationSubCode": luLocationSubCode,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuActClass(luBilledActId: string, luActClass: string) {
        const method = "POST"
        const endpoint = "/clinical/updateLuActClass/"
        const json = {
            "luBilledActId": luBilledActId,
            "luActClass": luActClass,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateContestationReason(invoiceId: string, contestationReason: string, contestationId: string, contestationType: string) {
        const method = "POST"
        const endpoint = "/clinical/updateContestationReason/"
        const json = {
            "invoiceId": invoiceId,
            "contestationReason": contestationReason,
            "contestationId": contestationId,
            "contestationType": contestationType,

        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateCancellationReason(invoiceId: string, cancellationReason: string) {
        const method = "POST"
        const endpoint = "/clinical/updateCancellationReason/"
        const json = {
            "invoiceId": invoiceId,
            "cancellationReason": cancellationReason,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addPidSimulationToEtransferData(invoiceId: string, patientPart: string, cnsPart: string, cnsAuthorizationUuid: string, cnsAuthorizationNumber: string, pidSimulationTimestamp: Date) {
        const method = "POST"
        const endpoint = "/clinical/addPidSimulationToEtransferData/"
        const json = {
            "invoiceId": invoiceId,
            "patientPart": patientPart,
            "cnsPart": cnsPart,
            "cnsAuthorizationUuid": cnsAuthorizationUuid,
            "cnsAuthorizationNumber": cnsAuthorizationNumber,
            "pidSimulationTimestamp": pidSimulationTimestamp,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addPidValidationToEtransferData(invoiceId: string, pidValidationTimestamp: Date) {
        const method = "POST"
        const endpoint = "/clinical/addPidValidationToEtransferData/"
        const json = {
            "invoiceId": invoiceId,
            "pidValidationTimestamp": pidValidationTimestamp,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addPidContestationToEtransferData(invoiceId: string, pidContestationTimestamp: Date) {
        const method = "POST"
        const endpoint = "/clinical/addPidContestationToEtransferData/"
        const json = {
            "invoiceId": invoiceId,
            "pidContestationTimestamp": pidContestationTimestamp,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addRaValidationToEtransferData(invoiceId: string, raValidationTimestamp: Date) {
        const method = "POST"
        const endpoint = "/clinical/addRaValidationToEtransferData/"
        const json = {
            "invoiceId": invoiceId,
            "raValidationTimestamp": raValidationTimestamp,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addRaCancellationToEtransferData(invoiceId: string, raCancellationTimestamp: Date) {
        const method = "POST"
        const endpoint = "/clinical/addRaCancellationToEtransferData/"
        const json = {
            "invoiceId": invoiceId,
            "raCancellationTimestamp": raCancellationTimestamp,
        }
        return await apiSendJson(method, endpoint, json)
    },
}
